jQuery(document).ready(function(){

  if(jQuery('#content').hasClass('home-page')){
    var galleryTop = new Swiper('.gallery-top', {
      spaceBetween: 30,
      slidesPerView: 1,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });


    var galleryText = new Swiper('.gallery-text', {
      spaceBetween: 10,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      simulateTouch: false,
      shortSwipes : false,
      longSwipes : false,
    });

    galleryTop.controller.control = galleryText;
    swiperThumbs(galleryTop,0, {
        // Our default options
        element: 'swiper-thumbnails',
        activeClass: 'is-active'
    });
    jQuery('.type').height(jQuery('.gallery-top').width()*9/18);
    jQuery('.gallery-thumbs .miniature').height(jQuery('.gallery-thumbs .miniature').width()*9/8);
    jQuery ('.gallery-text').css('bottom',jQuery('.gallery-thumbs .miniature').height())
    jQuery('.ctf-item').height(jQuery('.ctf-author-avatar img').height()+3);
    jQuery(window).on('resize', function () {
      jQuery('.type').height(jQuery('.gallery-top').width()*9/18);
        jQuery('.gallery-thumbs .miniature').height(jQuery('.gallery-thumbs .miniature').width()*9/8);
        jQuery ('.gallery-text').css('bottom',jQuery('.gallery-thumbs .miniature').height())
        jQuery('.ctf-item').height(jQuery('.ctf-author-avatar img').height()+3);
    });
  jQuery('.gallery-text').css('visibility','visible');
    var oldIndex;
  galleryTop.on('slideChange',function(e){
    var path =".home-thumbs #"+galleryTop.activeIndex;
    jQuery(".home-thumbs .miniature").removeClass("active");
    jQuery(path).addClass("active");

  });


  //Soundcloud

  var player;
  var pOffset;
  var pWidth;
  var scrub;
  var seek;

  //get the player
  player  =  SC.Widget(jQuery('iframe.sc-widget')[0]);

  //progress bar
  pOffset = jQuery('.progress').offset(); //Zero the progress bar
  pWidth = jQuery('.progress').width();

  player.bind(SC.Widget.Events.READY, function(eventData) { setInfo();	}); //Set info on load
  player.bind(SC.Widget.Events.PLAY_PROGRESS, function(e) {
    if( e.relativePosition < 0.003 ) { setInfo(); }
    //Event listener when track is playing
    jQuery('.progress-bar').css('width', ( e.relativePosition*100)+"%");

    if( !jQuery(".play").hasClass('glyphicon-pause') ) {
      jQuery(".play")
          .removeClass('glyphicon-play')
          .addClass('glyphicon-pause');
    }
  });

  //play/pause
  player.bind(SC.Widget.Events.PAUSE, function(e) {   //Event listener when track is paused
      setInfo();
      jQuery(".play")
        .addClass('glyphicon-play')
        .removeClass('glyphicon-pause');
  });

  //move progress
  jQuery('.progress').mousemove(function(e){ //Get position of mouse for scrubbing
    scrub = (e.pageX-pOffset.left);
  });

  jQuery('.progress').click(function(){ //Use the position to seek when clicked
    jQuery('.progress-bar').css('width',scrub+"px");
    seek = player.duration*(scrub/pWidth);
    player.seekTo(seek);
  });

  //Buttons
  jQuery('.play').click(function(){ player.toggle(); });
  jQuery('.backward').click(function(){ player.prev(); });
  jQuery('.forward').click(function(){ player.next(); });

  //get informations
  function setInfo() {
    player.getCurrentSound(function(song) {
      if(!song) {
        jQuery('.play').css('background-image', '');
        jQuery('.song').html('No artist found :(');
        return;
      }
      jQuery('.play').css('background-image', "url('" + song.artwork_url.replace('-large', '-t500x500') + "')");
      jQuery('.song').html(song.title);
      player.current = song;
    });

    player.getDuration(function(value){
      player.duration = value;
    });

    player.isPaused(function(bool){
      player.getPaused = bool;
    });
  }


  function resizeElements(){
  	pOffset = jQuery('.progress').offset(); //Zero the progress bar
    pWidth = jQuery('.progress').width();
  }
  jQuery(window).resize(function() {
    //resize just happened, pixels changed
  	resizeElements();
  });
  //END SOUNDCLOUD

  }

    if(jQuery('#content').hasClass('galerie-page')){
      var galleryPage = new Swiper('.gallery-slider', {
        spaceBetween: 10,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });

      var galleryPageText = new Swiper('.gallery-slider-text', {
        spaceBetween: 10,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
      },
        observer: true,
        observeParents: true,
        simulateTouch: false,
        shortSwipes : false,
        longSwipes : false,
      });

      galleryPage.controller.control = galleryPageText;
      swiperThumbs(galleryPage,1, {
          // Our default options
          element: 'swiper-thumbnails',
          activeClass: 'is-active'
      });

  jQuery('.starred .type').height(jQuery('.type').width()*9/16);
  jQuery('.miniature').height(jQuery('.starred-data').height()/2+1);
  jQuery(window).on('resize', function () {
    jQuery('.miniature').height(jQuery('.starred-data').height()/2+1);
  });

  // On lie l'événement resize à la fonction
  window.addEventListener('resize', redimensionnement, false);
  jQuery('[data-reveal]').on('open.zf.reveal', function() {
    setTimeout(redimensionnement, 50);
  });

  // Fonction exécutée au redimensionnement
  function redimensionnement() {
    var result = document.getElementById('result');
    if("matchMedia" in window) { // Détection
      var sizeText = jQuery('.gallery-slider-text').height();
      var mediaQ = sizeText*2;
      if(window.matchMedia("(min-height:"+mediaQ+"px)").matches) {
        jQuery('.reveal .gallery-slider').height(jQuery(window).height()-sizeText);
      } else {
        jQuery('.reveal .gallery-slider').height(jQuery(window).height()-50);
      }
    }
  }
}

    var citationText = new Swiper('.footer-citation', {
      spaceBetween: 10,
      effect: 'fade',
      fadeEffect: {
    crossFade: true
  },
      loop:true,
      autoplay: {
        delay: 5000,
    },
    });

  jQuery('.publication-page').on('click','.read-more',function(){
    var index = jQuery(this).attr("index");
    jQuery( "."+index ).toggleClass( "hide" );

  });
});
